import columns from "./columns";
import formFields from "./formFields";
import previewFields from "./previewFields";

export default {
    entityName: "branches",
    pageTitle: "Branches",
    displayName: "branches",
    columns,
    searchPlaceholder: "e.g. name:savola",
    formFields,
    previewFields,
    tableOptions: {},
    formOptions: {},
};
